import { CustomerType } from "@/api-schema-enums";
import { getCustomerTypeLabel } from "@/common/helpers/customer-display";
import { ReactElement } from "react";
import { BaseFilterProps, Filter, FilterData } from "../_types";
import { FilterComponent } from "../base-filter";

function getCustomerTypeOptions(): { id: CustomerType; name: string }[] {
  return Object.values(CustomerType).map((type) => ({ id: type, name: getCustomerTypeLabel(type) }));
}

/**
 * Filter for customer type
 * Uses the `type` field of the customer search body schema
 */
export class CustomerTypeFilter extends Filter<{ type?: CustomerType[] }, Record<string, never>> {
  readonly id: string = "type";
  readonly labelSingular = "masterdata:CustomerType";
  readonly labelPlural = "masterdata:CustomerType";
  readonly placeholder = "masterdata:SelectCustomerType";
  readonly searchPlaceholder = "masterdata:SearchCustomerType";
  readonly emptyText = "masterdata:NoCustomerTypeFound";
  body = {};
  parameters = {};

  constructor({ id }: { id?: string } = {}) {
    super();
    if (id) this.id = id;
  }

  getData(): FilterData {
    return {
      options: getCustomerTypeOptions(),
      isLoading: false,
      error: null,
    };
  }

  render(props: BaseFilterProps): ReactElement {
    return <FilterComponent filter={this} {...props} />;
  }
}
